import LazyLoadHandler from './scripts/modules/lazyLoad';

const init = () => {
    LazyLoadHandler.init();
};

init();
